import { render, staticRenderFns } from "./EditImageForm.vue?vue&type=template&id=1a8df6e7"
import script from "./EditImageForm.vue?vue&type=script&lang=js"
export * from "./EditImageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports